import { BaseService } from '../../infra/base.service'
import type { Goalboard } from './goalboard.entity'
import type { GoalboardsRepository } from './goalboards.repsoitory'

export class GoalboardsService extends BaseService<Goalboard> {
    constructor(private rep: GoalboardsRepository) {
        super(rep)
    }
}
